/**
 * BaseModal Barrel Export
 */

export { BaseModal } from './BaseModal';
export type { BaseModalProps } from './BaseModal';


